module.exports = __webpack_public_path__ + "img/user.b58b1f64.png";